import React from "react"
import ReactDOM from "react-dom/client"
import AppContainer from "./containers/AppContainer"

import { logInfo } from "@omnix-ia/logger"

logInfo("v1.2.61")
// logWarn("1.2.18")
// logError("1.2.18")
// logDebug({ state: "1.2.18" })

// Mute harmless ResizeObserver warnings from Webpack during development
const setupResizeObserverLoopMute = () => {
  const preventResizeObserverErrors = (e: ErrorEvent) => {
    if (
      e.message === "ResizeObserver loop limit exceeded" ||
      e.message === "ResizeObserver loop completed with undelivered notifications."
    ) {
      const resizeObserverErrDiv = document.getElementById("webpack-dev-server-client-overlay-div")
      const resizeObserverErr = document.getElementById("webpack-dev-server-client-overlay")
      if (resizeObserverErr) {
        resizeObserverErr.setAttribute("style", "display: none")
      }
      if (resizeObserverErrDiv) {
        resizeObserverErrDiv.setAttribute("style", "display: none")
      }
      e.stopImmediatePropagation()
    }
  }
  window.addEventListener("error", preventResizeObserverErrors)
}
setupResizeObserverLoopMute()

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>,
)
